import { Component, OnInit } from '@angular/core';
import { SearchTileComponent } from '../search-tile/search-tile.component';
import { SearchRequestEnvelope } from '../../../models/net/envelope/search-request-envelope';
import { MessageSearchRequest } from '../../../models/net/request/message-search-request';
import { MessageSeverity } from '../../../enums/message-severity';
import { ComponentDialogComponent } from '../../component-dialog/component-dialog.component';

@Component({
    selector: 'app-message-search-tile',
    templateUrl: './message-search-tile.component.html',
    styleUrls: ['./message-search-tile.component.css', '../../../app.component.css']
})

export class MessageSearchTileComponent extends SearchTileComponent {

    public fromLabel: string = "From Name";
    public toLabel: string = "To Name";
    public fromPlaceholder: string = "(From name)";
    public toPlaceholder: string = "(To name)";
    public subjectLabel: string = "Subject";
    public subjectPlaceholder: string = "(Subject)";

    public override setDataSource = (dataSource: SearchRequestEnvelope, componentDialogComponent: ComponentDialogComponent): void => {

        this.componentDialogComponent = componentDialogComponent;
        this.itemEnvelope = dataSource;
        this.itemEnvelopeSnapshot = this.appService.cloneObject(this.itemEnvelope);

        this.itemSearchRequest = JSON.parse(this.itemEnvelope.Document.Item.SearchRequestJson) as MessageSearchRequest;
        this.itemSearchRequestSnapshot = this.appService.cloneObject(this.itemSearchRequest);

        super.saveButtonCaption = this.itemSearchRequest.IsAdvancedSearch ? "SAVE AS ADVANCED SEARCH" : "SAVE AS BASIC SEARCH";

        this.addAppFeedMessage(MessageSeverity.Info, "Save and / or run either basic or advanced search", true);

        this.saveButtonCaption = this.saveButtonCaption;

        this.componentDialogComponent.titleChanged.subscribe((title: string) => {

            this.itemEnvelope.Document.Item.Name = title;
        });

        this.componentDialogComponent.subTitleChanged.subscribe((subtitle: string) => {

            this.itemEnvelope.Document.Item.Description = subtitle;
        });
    }
}
